import {
  Directive,
  Input,
  ElementRef,
  Renderer2,
  OnChanges,
  SimpleChanges,
} from '@angular/core';

@Directive({
  selector: '[appLeavecardcolor]',
  standalone: true,
})
export class LeavecardcolorDirective {
  @Input() appLeavecardcolor: any = ''; // The status input to control the color

  constructor(private ele: ElementRef, private renderer: Renderer2) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['appLeavecardcolor']) {
      this.setColor(this.appLeavecardcolor);
    }
  }

  private setColor(status: number | string): void {
    switch (status) {
      case 0:
      case 'PENDING':
        this.renderer.setStyle(
          this.ele.nativeElement,
          'background-color',
          '#FFE58F'
        );
        break;
      case 1:
      case 'SUBMITTED':
        this.renderer.setStyle(
          this.ele.nativeElement,
          'background-color',
          '#42526E'
        );
        break;
      case 2:
      case 'GRADED':
        this.renderer.setStyle(
          this.ele.nativeElement,
          'background-color',
          '#B8F8BA'
        );
        break;
      default:
        this.renderer.setStyle(
          this.ele.nativeElement,
          'background-color',
          '#fff'
        );
        // this.renderer.setStyle(this.ele.nativeElement, 'color', 'black');
        break;
    }
  }
}
